import React, { Component } from 'react';
import { RequiresAuthenticatedUser } from '../../RequiresAuthenticatedUser';
import StringConstant from '../../../constants/StringConstants';
import ManagePaymentActionCreator from '../../../actions/ManagePaymentActionCreator';
import EditPaymentsStore_new from '../../../stores/EditPaymentsStore_new';
import ActiveStandingOrderRepeatingFields from '../activepayments/ActiveStandingOrderRepeatingFields';
import ActiveStandingOrderSingleFields from '../activepayments/ActiveStandingOrderSingleFields';
import SvgIcon from '../../common/SvgIcon';
import { sayLandingMessage } from '../../../actions/AccessibilityActionCreator';

class EditPaymentSuccess extends Component {
  constructor(props) {
    super(props);
    this.showSubHeader = this.showSubHeader.bind(this);
    this.viewPayment = this.viewPayment.bind(this);
    this.state = {
      editedData: EditPaymentsStore_new.getPaymentData(),
    };
  }

  componentDidMount() {
    sayLandingMessage('Manage your scheduled payments edit payment');
  }

  goBack() {
    ManagePaymentActionCreator.navigateToWebTask('WEB-MANAGE-PAYMENT');
  }

  viewPayment() {
    if (this.state.editedData.soType === 'SINGLE') {
      return (
        <ActiveStandingOrderSingleFields activeData={this.state.editedData} />
      );
    } else {
      return (
        <ActiveStandingOrderRepeatingFields
          activeData={this.state.editedData}
        />
      );
    }
  }

  showSubHeader() {
    let subHeaderContent = '';
    let soTypeContent = '';
    if (this.state.editedData.soType === 'SINGLE') {
      soTypeContent = 'One off';
    } else {
      soTypeContent = 'repeating';
    }
    subHeaderContent = (
      <div className="c-media move-money__summary__message">
        <div className="c-media__thumb">
          <SvgIcon id="icon-success" width="64px" height="64px" />
        </div>
        <div className="c-media__body">
          <p>
            Your {soTypeContent} payment to{' '}
            <strong className="word-break-all">
              {this.state.editedData.toAccountName}
            </strong>
            <br />
            for &pound;<strong>{this.state.editedData.amount}</strong> has been
            edited.
          </p>
        </div>
      </div>
    );
    return subHeaderContent;
  }

  editPayment() {
    ManagePaymentActionCreator.navigateToWebTask('WEB-EDIT-PAYMENT');
  }

  goToAccount() {
    ManagePaymentActionCreator.navigateToWebTask('WEB-HOMEPAGE');
  }

  showOptions() {
    return (
      <div>
        <button onClick={this.goToAccount} className="c-btn c-btn--secondary">
          {StringConstant.accountGO}
        </button>
        &nbsp; &nbsp;
        <button className="c-btn c-btn--default" onClick={this.goBack}>
          View your scheduled payments
        </button>
      </div>
    );
  }

  render() {
    return (
      <div className="bow page move-money">
        <div className="container">
          <div className="row">
            <div className="col-xs1-24 col-md1-18">
              {/* <span id="accessH1ID" ref = "accessH1ID" tabIndex = "0" className="u-visually-hidden off-screen">You are on Manage your scheduled payments edit payment page</span>				 */}
              <h3>{this.props.content.allDoneMessage}</h3>
              {this.showSubHeader()}
              {this.viewPayment()}
              <p>{StringConstant.cancelledDDSOSuccessBody}</p>
              {this.showOptions()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RequiresAuthenticatedUser(EditPaymentSuccess);
